import { useNavigate } from 'react-router-dom';
import config from '../../config';
import chatService from '../../services/chat.service';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { toast } from 'react-toastify';
import { calculateAge } from '../../utils/calculateAge';

export const NotificationCard = ({ notification, onRead, option }) => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  // Извлекаем данные из notification
  const type = notification?.type;
  const payload = notification?.payload || {};
  const isNew = !notification?.seen;
  const isSuperlike = type === 'superlike';

  // Получаем информацию о пользователе из payload
  const userId = payload?._id;
  const isDeletedUser = Boolean(payload?.isDeleted);
  const canOpenUserProfile = Boolean(userId && !isDeletedUser);
  const userName = payload?.name || (isDeletedUser ? 'Удаленный пользователь' : 'Пользователь');
  const userAge = isDeletedUser ? '' : calculateAge(payload?.birthDay) || '';
  const userTitle = userAge ? `${userName}, ${userAge} лет` : userName;
  const userPhoto = payload?.photo;

  const handleUnavailableProfile = () => {
    toast.error('Профиль пользователя больше недоступен');
  };

  // Определяем текст уведомления
  const getNotificationText = () => {
    switch (type) {
      case 'like':
        return 'Вам поставили лайк!';
      case 'superlike':
        return 'Вам поставили СУПЕРЛАЙК!';
      case 'mutual':
        return 'У вас взаимная симпатия с';
      case 'gift':
        return 'Вам отправили подарок!';
      default:
        return payload?.message || 'Новое уведомление';
    }
  };

  const handleClick = () => {
    if (!notification._id) return;

    if (isSuperlike) {
      if (!canOpenUserProfile) return handleUnavailableProfile();
      navigate(config.ROUTES.MATCHS.SUPER_LIKE_PROFILE_ID(userId, notification._id), {
        state: {
          from: config.ROUTES.NOTIFICATIONS,
          notificationOption: option
        }
      });
    } else if (type === 'mutual') {
      if (!canOpenUserProfile) return handleUnavailableProfile();
      handleToFindOrCreateChat();
    } else if (userId) {
      if (!canOpenUserProfile) return handleUnavailableProfile();
      navigate(config.ROUTES.MATCHS.SUPER_LIKE_PROFILE_ID(userId, notification._id), {
        state: {
          from: config.ROUTES.NOTIFICATIONS,
          notificationOption: option
        }
      });
    }
  };

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id), {
        state: {
          from: config.ROUTES.NOTIFICATIONS,
          notificationOption: option
        }
      });
    } catch (error) {
      const message = error?.response?.data?.message;

      console.error('[Profile] getChatToUserId:', error);
      toast.error(message || 'Ошибка при попытке открыть чат с пользователем');
    }
  };

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    if (!canOpenUserProfile) {
      handleUnavailableProfile();
      return;
    }

    if (userId) {
      navigate(config.ROUTES.CHATS.PROFILE(userId));
    }
  };

  return (
    <div
      className={`text-white w-full flex flex-row h-[84px] items-center font-raleway cursor-pointer hover:bg-[#FFFFFF0A] transition-colors`}
      onClick={handleClick}
    >
      {userPhoto ? (
        <img
          src={userPhoto}
          alt="Аватар пользователя"
          className="w-[48px] h-[48px] rounded-[50%] ml-[16px] mr-[16px] object-cover shrink-0 cursor-pointer"
          onClick={handleAvatarClick}
        />
      ) : (
        <div
          className="w-[48px] h-[48px] rounded-[50%] ml-[16px] mr-[16px] bg-[#233636] text-white flex items-center justify-center text-[20px] shrink-0"
          onClick={handleAvatarClick}
        >
          ?
        </div>
      )}
      <div className="flex flex-col w-[220px] gap-1">
        <p className="text-[14px] font-normal">{getNotificationText()}</p>
        <p className="text-[16px] font-semibold leading-[24px]">{userTitle}</p>
      </div>
      <div className="ml-auto flex flex-col justify-center w-[100px] items-end mr-3">
        {isNew && (
          <div
            className={`rounded-[400px] bg-[#A1F69E] w-[58px] h-[25px] flex items-center justify-center text-black font-semibold text-[12px]`}
          >
            NEW
          </div>
        )}
        {isSuperlike && (
          <img src="/icons/bg-superlike.svg" alt="Суперлайк" className="absolute w-[84px] h-[84px] right-0" />
        )}
      </div>
    </div>
  );
};
